// src/pages/LeavingAgents.js
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import living from '../assets/images/category/living agent.jpg';

const LeavingAgents = () => {
  const products = [
    {
      name: "Baking Powder",
      category: "LEAVENING AGENT",
      description: "Premium baking powder formulations for consistent leavening across all your baking needs. From quick-acting to double-acting systems, we provide reliable rise and excellent volume every time.",
      features: [
        "Double-Acting Formula : Releases gas in two stages—during mixing and baking for superior rise",
        "Aluminum-Free Options : Clean-label formulations for health-conscious consumers",
        "Stable Performance : Consistent leavening action across varying storage and baking conditions",
        "Versatile Applications : Suitable for cakes, muffins, biscuits, and quick breads"
      ],
      image: "/assets/images/baking-powder.jpg"
    },
    {
      name: "Leavening Acids",
      category: "LEAVENING ACIDS",
      description: "Premium leavening acid solutions for controlled gas release and optimal product characteristics. Our range includes fast, medium, and slow-acting acids for precise fermentation control.",
      features: [
        "GDL (Glucono Delta-Lactone PH) : Slow-release acid for extended shelf-life and controlled leavening",
        "Sodium Aluminum Phosphate (SALP) : High-performance leavening acid for superior volume and texture",
        "Sodium Acid Pyrophosphate (SAPP) : Fast to slow-acting options for customized release profiles",
        "Monocalcium Phosphate (MCP) : Quick-acting acid for immediate gas release during mixing"
      ],
      image: "/assets/images/leavening-acids.jpg"
    },
    {
      name: "High-Performance Dry Yeast",
      category: "YEAST",
      description: "Enessa Fresh Instant Dry Yeast: Ultra-quick activation, strong fermentation power, and excellent gas production. Perfect for high-speed production lines and consistent, reliable results in all bread applications.",
      features: [
        "Strong Fermentation : Powerful gas production for excellent volume and oven spring",
        "Instant Activation : No pre-hydration needed—mix directly with flour",
        "Long Shelf-Life : Stable product with extended viability under proper storage",
        "Versatile Applications : Suitable for breads, pizza, buns, and enriched dough"
      ],
      image: "/assets/images/dry-yeast.jpg"
    }
  ];

  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Complete dough strengthening solutions.",
      itemCount: 12,
      image: image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Premixes & Concentrates",
      description: "Ready-to-use formulations.",
      itemCount: 14,
      image: image3,
      link: "/products/premixes"
    },
    {
      title: "Shelf-Life Enhancers & Preservatives",
      description: "Extended freshness solutions.",
      itemCount: 10,
      image: image4,
      link: "/products/shelf-life"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Superior texture development.",
      itemCount: 8,
      image: image5,
      link: "/products/emulsifiers"
    },
    {
      title: "Specialty Enzymes",
      description: "Biological dough improvers.",
      itemCount: 17,
      image: image6,
      link: "/products/enzymes"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "Specialty ingredients.",
      itemCount: 20,
      image: image7,
      link: "/products/other-ingredients"
    },
    {
      title: "Quality Assurance",
      description: "Quality you can trust.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "Browse all products.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Leavening Agents (Raising Agents)"
      description="Rise to new heights—perfect volume and texture every time. Our comprehensive range of leavening solutions ensures consistent performance, whether you're making delicate cakes or hearty breads."
      heroImage={living}
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default LeavingAgents;